/**
 * @generated SignedSource<<30e0a2a9c8d1afc3c8b23586be23cad0>>
 * @relayHash 06b9fb035af57083d93e14e4ef85a0dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d4c7ec1badb095312c7161498c73527249e67a092e06ecbe4b411d6573f4b420

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CustomJourneyTypePageQuery } from './CustomJourneyTypePageQuery.graphql';

import isJsmRovoServiceHrAgentEnabled_provider from '@jira/platform__graphql-relay-provider/src/jsm-rovo-service-hr-agent.relayprovider';

const node: PreloadableConcreteRequest<CustomJourneyTypePageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d4c7ec1badb095312c7161498c73527249e67a092e06ecbe4b411d6573f4b420",
    "metadata": {},
    "name": "CustomJourneyTypePageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmrovoservicehragentrelayprovider": isJsmRovoServiceHrAgentEnabled_provider
    }
  }
};

export default node;
